import Vue from 'vue'
import VSelect from '../components/shared/VSelect';

Vue.mixin({
    components: {
        VSelect
    }
});
